import MenuNames from "./MenuNames.json";

const data = {
  /* PLOP_TEMPLATE_MENU_ACTION_MAPPINGS */
  [MenuNames.DISPUTES]: {
    DISPUTES_VIEW: "DISPUTES_VIEW",
    BULK_UPLOAD: "BULK_REVERT_DISPUTES",
  },
  [MenuNames.BULK_UPLOAD_BONUSES]: {
    BULK_UPLOAD: "BULK_UPLOAD_BONUSES",
  },
  [MenuNames.BULK_UPLOAD_OB_TAGS]: {
    BULK_UPLOAD: "BULK_UPLOAD_OB_TAGS",
  },
  [MenuNames.BULK_UPLOAD_DRIVER_SECONDARY_LOCALITY_MAPPING]: {
    BULK_UPLOAD: "BULK_UPLOAD_DRIVER_SECONDARY_LOCALITY_MAPPING",
  },
  [MenuNames.BULK_UPSERT_POLYGON]: {
    BULK_UPSERT: "BULK_UPSERT_POLYGON",
  },
  [MenuNames.INCENTIVE_MULTIPLIERS]: {
    BULK_UPLOAD: "BULK_UPLOAD_INCENTIVE_MULTIPLIERS"
  },
  [MenuNames.EV_INVENTORY]: {
    BULK_UPLOAD: "BULK_EV_INVENTORY_UPLOAD",
  },
  [MenuNames.DRIVER_SHELTER]: {
    READ: "DRIVER_SHELTER_READ",
    CREATE: "DRIVER_SHELTER_CREATE",
    UPDATE: "DRIVER_SHELTER_UPDATE",
    BULK_UPLOAD: "DRIVER_SHELTER_UPDATE",
  },
  [MenuNames.WALKER]: {
    BULK_UPLOAD: "BULK_WALKER_ONBOARDING",
    BULK_POI_UPLOAD: "BULK_POI_ONBOARDING",
    WALKER_DETAILS_VIEW: "WALKER_DETAILS_VIEW",
  },
  [MenuNames.SPIN_THE_WHEEL]: {
    BULK_INVENTORY_UPLOAD: "BULK_INVENTORY_UPLOAD",
    INVENTORIES_LIST: "INVENTORIES_LIST",
    BULK_COUPON_UPLOAD: "BULK_COUPON_UPLOAD",
  },
  [MenuNames.ORDER_PAYOUT]: {
    ORDER_PAYOUT: "ORDER_PAYOUT",
  },
  [MenuNames.OFS_CACHE_DASHBOARD]: {
    OFS_CACHE_VIEW: "OFS_CACHE_VIEW",
  },
  [MenuNames.ORDERS]: {
    ORDERS_VIEW: "ORDERS_VIEW",
    ORDERS_EDIT: "ORDERS_EDIT",
  },
  [MenuNames.LIFELINE]: {
    LIFELINE: "LIFELINE",
    LIFELINE_CALLLOGS: "LIFELINE_CALLLOGS",
    LIFELINE_CONNECT_OUTGOING_CALL: "LIFELINE_CONNECT_OUTGOING_CALL",
    LIFELINE_ORDER_ACTIONS: "LIFELINE_ORDER_ACTIONS",
    LIFELINE_ACTION_REASONS: "LIFELINE_ACTION_REASONS",
    LIFELINE_PAYMENTS: "LIFELINE_PAYMENTS",
  },
  [MenuNames.BULK_UPLOAD_CARRIER_CHANGE_MANAGER]: {
    BULK_UPLOAD: "BULK_UPLOAD_CARRIER_CHANGE",
  },
  [MenuNames.FLEET_COACH_V2]: {
    LIST: "FLEET_COACH_READ",
    CREATE: "FLEET_COACH_UPDATE",
    BULK_UPLOAD: "BULK_UPLOAD_DRIVER_FC_MAPPING",
    ADMIN: "FLEET_COACH_ADMIN",
  },
  [MenuNames.FLEET_COACH_TASK_V2]: {
    FLEET_COACH_TASK_CREATE: "FLEET_COACH_TASK_CREATE",
    FLEET_COACH_TASK_VIEW: "FLEET_COACH_TASK_VIEW",
  },
  [MenuNames.FLEET_COACH_APP_RELEASE_V2]: {
    LIST: "FLEET_COACH_APP_RELEASE_LIST",
    UPDATE: "FLEET_COACH_APP_RELEASE_UPDATE",
  },
  [MenuNames.FLEET_COACH]: {
    LIST: "FLEET_COACH_READ",
    CREATE: "FLEET_COACH_UPDATE",
    BULK_UPLOAD: "BULK_UPLOAD_DRIVER_FC_MAPPING",
    ADMIN: "FLEET_COACH_ADMIN",
  },
  [MenuNames.FLEET_COACH_TASK]: {
    FLEET_COACH_TASK_CREATE: "FLEET_COACH_TASK_CREATE",
    FLEET_COACH_TASK_VIEW: "FLEET_COACH_TASK_VIEW",
  },
  [MenuNames.PENDING_DEDUCTION]: {
    LIST: "PENDING_DEDUCTION_LEDGERS",
    BULK_UPLOAD: "PENDING_DEDUCTION_BULK_UPLOAD",
  },
  [MenuNames.GIGS_SUPPORT]: {
    LIST: "GIGS_SUPPORT_LIST",
  },
  [MenuNames.SLOT_CAPACITY_UPDATE]: {
    BULK_UPLOAD: "DRIVER_SLOT_CAPACITY_UPDATE",
    LIST_CAPACITY_CHANGE: "LIST_MANUAL_CAPACITY_UPDATE_REQUEST",
    CREATE_CAPACITY_CHANGE_REQUEST: "CREATE_MANUAL_CAPACITY_UPDATE_REQUEST",
    APPROVE_CAPACITY_CHANGE_REQUEST: "APPROVE_MANUAL_CAPACITY_UPDATE_REQUEST",
  },
  [MenuNames.MANUAL_SLOT_CAPACITY_UPDATE]: {
    LIST: "LIST_MANUAL_CAPACITY_UPDATE_REQUEST",
    CREATE: "CREATE_MANUAL_CAPACITY_UPDATE_REQUEST",
    APPROVE: "APPROVE_MANUAL_CAPACITY_UPDATE_REQUEST",
  },
  [MenuNames.DRIVER_SLOT_VIEW_DETAILS]: {
    SLOT_VIEW_DETAILS: "DRIVER_SLOT_VIEW_DETAILS",
  },
  [MenuNames.GEO_BOUNDARIES_DISPLAY]: {
    LOCALITY_BOUNDARIES: "LOCALITY_BOUNDARIES",
  },
  [MenuNames.RIDER_PAYOUT_HISTORY]: {
    LIST: "RIDER_PAYOUT_HISTORY_LIST",
  },
  [MenuNames.DRIVER_SELFIES]: {
    LIST: "DRIVER_SELFIES_LIST",
  },
  [MenuNames.DRIVER_ASSET_ISSUANCE_TRACKING]: {
    LIST: "DRIVER_ASSET_ISSUANCE_TRACKING_LIST",
  },
  [MenuNames.FEATURE_TOGGLE]: {
    LIST: "FEATURE_TOGGLE_LIST",
    DETAIL: "FEATURE_TOGGLE_DETAIL",
    CREATE: "FEATURE_TOGGLE_CREATE",
    UPDATE: "FEATURE_TOGGLE_UPDATE",
    BULK_CREATE: "FEATURE_TOGGLE_BULK_CREATE",
    BULK_DELETE: "FEATURE_TOGGLE_BULK_DELETE",
    DELETE: "FEATURE_TOGGLE_DELETE",
  },
  [MenuNames.FEATURE_CONFIG]: {
    VIEW: "FEATURE_CONFIG_VIEW",
  },
  [MenuNames.FEATURE]: {
    LIST: "FEATURE_LIST",
    DETAIL: "FEATURE_DETAIL",
    CREATE: "FEATURE_CREATE",
    UPDATE: "FEATURE_UPDATE",
    DELETE: "FEATURE_DELETE",
    TOGGLE_DELETE: "FEATURE_TOGGLE_DELETE",
  },
  [MenuNames.TRAINING]: {
    LIST: "TRAINING_LIST",
    ASSIGNED_COURSE: "TRAINING_ASSIGNED_COURSE",
    COURSE_INFO: "TRAINING_COURSE_READ",
    ASSIGN_COURSE: "TRAINING_ASSIGN_COURSE",
    CREATE_EDIT_COURSE: "TRAINING_COURSE_CREATE_AND_EDIT",
    LANGUAGES_LIST: "TRAINING_LANGUAGES_LIST",
  },
  [MenuNames.COUNTRY]: {
    LIST: "COUNTRY_LIST",
    DETAIL: "COUNTRY_DETAIL",
    UPDATE: "COUNTRY_UPDATE",
    CREATE: "COUNTRY_CREATE",
    DELETE: "COUNTRY_DELETE",
  },
  [MenuNames.STATE]: {
    LIST: "STATE_LIST",
    DETAIL: "STATE_DETAIL",
    UPDATE: "STATE_UPDATE",
    CREATE: "STATE_CREATE",
  },
  [MenuNames.CITY]: {
    LIST: "CITY_LIST",
    DETAIL: "CITY_DETAIL",
    UPDATE: "CITY_UPDATE",
    CREATE: "CITY_CREATE",
    EDIT_CITY_SUPPORTED: "EDIT_CITY_AND_CITY_SUPPORTED",
  },
  [MenuNames.LOCALITY]: {
    LIST: "LOCALITY_LIST",
    DETAIL: "LOCALITY_DETAIL",
    UPDATE: "LOCALITY_UPDATE",
    CREATE: "LOCALITY_CREATE",
  },
  [MenuNames.POLYGON]: {
    LIST: "POLYGON_LIST",
    DETAIL: "POLYGON_DETAIL",
    UPDATE: "POLYGON_UPDATE",
    CREATE: "POLYGON_CREATE",
    TYPES: "POLYGON_TYPES",
  },
  [MenuNames.CONFIG]: {
    GET_CITY_PROPERTY: "CONFIG_GET_CITY_PROPERTY",
    CITY_PROPERTY_UPDATE: "CONFIG_CITY_PROPERTY_UPDATE",
    GET_GEN_SETTING: "CONFIG_GET_GEN_SETTING",
    GEN_SETTING_UPDATE: "CONFIG_GEN_SETTING_UPDATE",
    GET_FINAL_CONFIG: "CONFIG_GET_FINAL_CONFIG",
    GET_LEVEL: "CONFIG_GET_LEVEL",
    GET_SCHEMA: "CONFIG_GET_SCHEMA",
    GET_GEN_SETTING_CHANGE_LOGS: "CONFIG_GET_GEN_SETTING_CHANGE_LOGS",
    GET_CITY_PROPERTY_CHANGE_LOGS: "CONFIG_GET_CITY_PROPERTY_CHANGE_LOGS",
    GET_CITY_PROPERTY_KEYS: "CONFIG_GET_CITY_PROPERTY_KEYS",
    GET_GEN_SETTING_KEYS: "CONFIG_GET_GEN_SETTING_KEYS",
  },
  [MenuNames.DRIVER_TAG]: {
    LIST: "DRIVER_TAG_LIST",
    DETAIL: "DRIVER_TAG_DETAIL",
    UPDATE: "DRIVER_TAG_UPDATE",
    CREATE: "DRIVER_TAG_CREATE",
    BULK_UPLOAD_OTHER_TAG: "DRIVER_TAG_MAPPING_BULK_UPLOAD_OTHER_TAG",
    BULK_UPLOAD_FUTURE_ACCOUNTING_TAG:
      "DRIVER_TAG_MAPPING_BULK_UPLOAD_FUTURE_ACCOUNTING_TAG",
    MAPPING_LIST: "DRIVER_TAG_MAPPING_LIST",
  },
  [MenuNames.DRIVER_ACCOUNTING]: {
    SETTLEMENT_PROCESS_LIST: "DRIVER_ACCOUNTING_SETTLEMENT_PROCESS_LIST",
    SETTLEMENT_PROCESS_WRITE: "DRIVER_ACCOUNTING_SETTLEMENT_PROCESS_WRITE",
  },
  [MenuNames.DRIVER_ASSETS]: {
    BULK: "DRIVER_ASSETS_BULK",
    ISSUANCE: "DRIVER_ASSETS_ISSUANCE",
    ISSUANCE_LIST: "DRIVER_ASSETS_ISSUANCE_LIST",
    DRIVER_DETAIL: "DRIVER_DETAIL",
    CENTERS_IN_CITY: "ONBOARDING_CENTRES_IN_CITY",
  },
  [MenuNames.ASSET_MANAGEMENT]: {
    ASSET_MANAGEMENT: "ASSET_MANAGEMENT",
    DRIVER_DETAIL: "DRIVER_DETAIL",
  },
  [MenuNames.DRIVER_MEDALS]: {
    METRIC_DETAILS: "DRIVER_MEDALS_LIST",
    DRIVER_DETAIL: "DRIVER_DETAIL",
  },
  [MenuNames.ROLE_MANAGEMENT]: {
    ROLE_MANAGEMENT: "ROLE_MANAGEMENT",
  },
  [MenuNames.ATTRIBUTE_MAPPING]: {
    LIST: "LIST_USER_ATTRIBUTES",
    CREATE: "MANAGE_USER_ATTRIBUTES",
    UPDATE: "MANAGE_USER_ATTRIBUTES",
  },
  [MenuNames.BULK_UPLOAD_AUTH_DETAILS]: {
    BULK_UPLOAD_AUTH_DETAILS: "BULK_UPLOAD_AUTH_DETAILS",
  },
  [MenuNames.TRIP_LOCALITY_PROPERTY]: {
    BULK_UPLOAD: "BULK_UPLOAD_TRIP_LOCALITY_PROPERTY",
  },
  [MenuNames.DRIVER_CASH_TRANSACTIONS]: {
    LIST: "DRIVER_CASH_TRANSACTIONS_LIST",
  },
  [MenuNames.TELECALLER_PROFILE]: {
    LIST: "TELECALLER_PROFILE_LIST",
    EDIT: "TELECALLER_PROFILE_EDIT",
    CREATE: "TELECALLER_PROFILE_CREATE",
  },
  [MenuNames.TRIP_STATISTICS]: {
    LIST: "TRIP_STATISTICS_LIST",
  },
  [MenuNames.TELECALLER_LEAD]: {
    TELECALLER_LEAD_ASSIGNMENT: "TELECALLER_LEAD_ASSIGNMENT",
  },
  [MenuNames.ASSETS_ISSUANCE]: {
    CREATE: "ASSETS_ISSUANCE_CREATE",
  },
  [MenuNames.LEADS_BULK_UPLOAD]: {
    LEADS_BULK_UPLOAD: "LEADS_BULK_UPLOAD",
  },
  [MenuNames.TDS_AND_RIDER_PAYOUT_JOBS]: {
    LIST: "TDS_AND_RIDER_PAYOUT_JOBS_LIST",
    TRIGGER_JOBS: "TDS_AND_RIDER_PAYOUT_JOBS_TRIGGER",
  },
  [MenuNames.BULK_UPDATE_TDS_PROPERTIES]: {
    BULK_UPLOAD: "BULK_UPDATE_TDS_PROPERTIES",
  },
  [MenuNames.RESTRICTED_PAYOUTS]: {
    BULK_UPLOAD: "BULK_UPDATE_RESTRICTED_PAYOUTS",
  },
  [MenuNames.DRIVER_SHIFT]: {
    LIST: "DRIVER_SHIFT_LIST",
    CREATE: "DRIVER_SHIFT_CREATE",
    DETAIL: "DRIVER_SHIFT_DETAIL",
    UPDATE: "DRIVER_SHIFT_UPDATE",
  },
  [MenuNames.DRIVER_SHIFT_GROUP]: {
    LIST: "DRIVER_SHIFT_GROUP_LIST",
    CREATE: "DRIVER_SHIFT_GROUP_CREATE",
    UPDATE: "DRIVER_SHIFT_GROUP_UPDATE",
  },
  [MenuNames.DRIVER_SHIFT_ZONE]: {
    CREATE: "DRIVER_SHIFT_ZONE_BULK_CREATE",
  },
  [MenuNames.DRIVER_SHIFT_MAPPING]: {
    CREATE: "DRIVER_SHIFT_MAPPING_BULK_CREATE",
  },
  [MenuNames.DRIVER_SHIFT_BULK_UPLOAD_AUDIT_HISTORY]: {
    SEARCH: "DRIVER_SHIFT_BULK_UPLOAD_AUDIT_HISTORY_SEARCH",
  },
  [MenuNames.DRIVER]: {
    DRIVER_DETAILS_EDIT: "DRIVER_DETAILS_EDIT",
    DRIVER_DETAILS_VIEW: "DRIVER_DETAILS_VIEW",
    DRIVER_NOTIFY: "DRIVER_NOTIFY",
    DRIVER_ADDITIONAL_DETAILS_VIEW: "DRIVER_ADDITIONAL_DETAILS_VIEW",
    DRIVER_ADDITIONAL_DETAILS_EDIT: "DRIVER_ADDITIONAL_DETAILS_EDIT",
    DRIVER_ASSIGNMENT_STATUS_VIEW: "DRIVER_ASSIGNMENT_STATUS_VIEW",
    DRIVER_ASSIGNMENT_STATUS_EDIT: "DRIVER_ASSIGNMENT_STATUS_EDIT",
    DRIVER_FINANCIAL_DETAILS_VIEW: "DRIVER_FINANCIAL_DETAILS_VIEW",
    DRIVER_FINANCIAL_DETAILS_EDIT: "DRIVER_FINANCIAL_DETAILS_EDIT",
    DRIVER_SERVICES_DETAILS_VIEW: "DRIVER_SERVICES_DETAILS_VIEW",
    DRIVER_SERVICES_DETAILS_EDIT: "DRIVER_SERVICES_DETAILS_EDIT",
    DRIVER_LOCALITIES_DETAILS_VIEW: "DRIVER_LOCALITIES_DETAILS_VIEW",
    DRIVER_LOCALITIES_DETAILS_EDIT: "DRIVER_LOCALITIES_DETAILS_EDIT",
    DRIVER_DOCUMENTS_VIEW: "DRIVER_DOCUMENTS_VIEW",
    DRIVER_DOCUMENTS_EDIT: "DRIVER_DOCUMENTS_EDIT",
    DRIVER_LIFECYCLE_EDIT: "DRIVER_LIFECYCLE_EDIT",
    DRIVER_CLEAR_SELFIE_CAMPAIGN: "DRIVER_CLEAR_SELFIE_CAMPAIGN",
    DRIVER_DESCRIPTION_EDIT: "DRIVER_ADDITIONAL_DETAILS_DESCRIPTION_EDIT",
    DRIVER_DOC_VERIFICATION_MANAGER: "DRIVER_DOC_VERIFICATION_MANAGER",
    DRIVER_TOGGLE_TEST_DRIVER_MANAGER: "DRIVER_TOGGLE_TEST_DRIVER_MANAGER",
  },
  [MenuNames.QUALITY_CHECK]: {
    READ: "QUALITY_CHECK_READ",
    WRITE: "QUALITY_CHECK_WRITE",
  },
  [MenuNames.QUALITY_CHECK_V2]: {
    READ: "QUALITY_CHECK_READ_V2",
    WRITE: "QUALITY_CHECK_WRITE_V2",
  },
  [MenuNames.DLRC_CHECK]: {
    READ: "DLRC_CHECK_READ",
    WRITE: "DLRC_CHECK_WRITE",
  },
  [MenuNames.MERCHANT_FACADE_PIC]: {
    READ: "MERCHANT_FACADE_PIC_READ",
    DELETE: "MERCHANT_FACADE_PIC_UPDATE",
  },
  [MenuNames.DRIVER_INFO_BULK_REQUEST]: {
    REQUEST_INFO: "DRIVER_INFO_BULK_REQUEST",
    REQUEST_CONTACT_INFO: "DRIVER_CONTACT_INFO_BULK_REQUEST",
    REQUEST_PERSONAL_INFO: "DRIVER_PERSONAL_INFO_BULK_REQUEST",
  },
  [MenuNames.LOGISTICS_CHAT_DEPARTMENTS]: {
    READ: "LOGISTICS_CHAT_DEPARTMENTS_READ",
    UPDATE: "LOGISTICS_CHAT_DEPARTMENTS_UPDATE",
  },
  [MenuNames.LOGISTICS_SUPPORT_DASHBOARD]: {
    CREATE: "LOGISTICS_SUPPORT_ISSUE_NODES_CREATE",
    UPDATE: "LOGISTICS_SUPPORT_ISSUE_NODES_UPDATE",
    LIST: "LOGISTICS_SUPPORT_ISSUE_NODES_LIST",
    DETAIL: "LOGISTICS_SUPPORT_ISSUE_NODES_DETAIL",
    CREATE_SUB_ISSUE_TYPE: "LOGISTICS_SUPPORT_SUB_ISSUE_NODES_CREATE",
    UPDATE_SUB_ISSUE_TYPE: "LOGISTICS_SUPPORT_SUB_ISSUE_NODES_UPDATE",
    LIST_SUB_ISSUE_TYPE: "LOGISTICS_SUPPORT_SUB_ISSUE_NODES_LIST",
    DETAIL_SUB_ISSUE_TYPE: "LOGISTICS_SUPPORT_SUB_ISSUE_NODES_DETAIL",
  },
  [MenuNames.DRIVER_APP_RELEASE]: {
    READ: "DRIVER_APP_RELEASE_READ",
    UPDATE: "DRIVER_APP_RELEASE_UPDATE",
    LAUNCH: "DRIVER_APP_RELEASE_LAUNCH",
  },
  [MenuNames.LOGISTICS_SUPPORT_DEPARTMENTS]: {
    READ: "LOGISTICS_SUPPORT_DEPARTMENTS_READ",
    UPDATE: "LOGISTICS_SUPPORT_DEPARTMENTS_UPDATE",
  },
  [MenuNames.USER_PROPERTY]: {
    CREATE: "USER_PROPERTY_CREATE",
    READ: "USER_PROPERTY_READ",
    UPDATE: "USER_PROPERTY_UPDATE",
  },
  [MenuNames.FLEET_COACH_APP_RELEASE]: {
    LIST: "FLEET_COACH_APP_RELEASE_LIST",
    UPDATE: "FLEET_COACH_APP_RELEASE_UPDATE",
  },
  [MenuNames.DRIVER_NOTIFICATION]: {
    CAMPAIGN_CREATE: "DRIVER_NOTIFICATION_CAMPAIGN_CREATE",
    CAMPAIGN_VIEW: "DRIVER_NOTIFICATION_CAMPAIGN_VIEW",
  },
  [MenuNames.DRIVER_STORIES]: {
    STORIES_VIEW: "DRIVER_STORIES_VIEW",
    STORIES_CREATE: "DRIVER_STORIES_CREATE",
  },
  [MenuNames.GROUND_INTELLIGENCE]: {
    RAIN_REPORTING: "RAIN_REPORTING",
  },
  [MenuNames.PRIZE_ITEMS]: {
    LIST: "PRIZE_ITEMS_LIST",
    DETAIL: "PRIZE_ITEMS_DETAIL",
    UPDATE: "PRIZE_ITEMS_UPDATE",
    BULK_CREATE: "PRIZE_ITEMS_BULK_CREATE",
  },
  [MenuNames.DRIVER_TDS_CERTIFICATES]: {
    VIEW: "DRIVER_TDS_CERTIFICATES_VIEW",
  },
  [MenuNames.CAMPAIGNS]: {
    LIST: "CAMPAIGN_LIST",
    DETAIL: "CAMPAIGN_CITY_MAPPINGS",
    UPSERT: "CAMPAIGN_UPSERT",
    BULK_CITIES_UPLOAD: "CAMPAIGN_CITY_MAPPINGS_UPLOAD",
  },
  [MenuNames.FEATURE_CONFIG]: {
    VIEW: "FEATURE_CONFIG_VIEW",
  },
  [MenuNames.DRIVER_RESERVATION]: {
    DRIVER_RESERVATIONS_BULK_CREATE: "DRIVER_RESERVATIONS_BULK_CREATE",
  },
  [MenuNames.RESTRICTED_PAYOUT_DRIVERS]: {
    VIEW: "RESTRICTED_PAYOUT_DRIVERS_VIEW",
  },
  [MenuNames.BULK_UPDATE_PAYOUT_HOLD]: {
    BULK_UPLOAD: "BULK_UPDATE_PAYOUT_HOLD",
  },
  [MenuNames.COMMUNICATION_HUB]: {
    COMMUNICATION_HUB_VIEW: "COMMUNICATION_HUB_VIEW",
    COMMUNICATION_HUB_CREATE: "COMMUNICATION_HUB_CREATE",
    COMMUNICATION_HUB_ASSIGN: "COMMUNICATION_HUB_ASSIGN",
    COMMUNICATION_HUB_FORCE_COMPLETE: "COMMUNICATION_HUB_FORCE_COMPLETE",
  },
  [MenuNames.DRIVER_ONBOARDING]: {
    DRIVER_ONBOARDING_APPLICATION_DETAILS:
      "DRIVER_ONBOARDING_APPLICATION_DETAILS",
  },
  [MenuNames.QR_GENERATOR]: {
    VIEW: "QR_GENERATOR_VIEW",
  },
  [MenuNames.DRIVER_BANNER]: {
    BANNER_VIEW: "DRIVER_BANNER_VIEW",
    BANNER_CREATE: "DRIVER_BANNER_CREATE",
  },
};

export default data;
